import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SurveyService } from '../../../services/survey.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerService } from '../../../services/spinner.service';
import { Survey } from '../../../models/survey.model';
import { SurveyModalComponent } from '../../../components/survey-modal/survey-modal.component';
import { NeighborhoodService } from '../../../services/neighborhood.service';

@Component({
  selector: 'app-surveys-page',
  templateUrl: './surveys-page.component.html',
  styleUrl: './surveys-page.component.scss'
})
export class SurveysPageComponent {

  public neighborhoodId: string = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    public surveyService: SurveyService,
    public neighborhoodService: NeighborhoodService,
    private modalService: NgbModal,
    public spinnerService: SpinnerService
  ) {
    this.activatedRoute.params.subscribe(
      async params => {
        this.neighborhoodId = params['neighborhoodId'];
        await this.surveyService.getAll(this.neighborhoodId!);
      }
    );
  }

  async delete(
    survey: Survey
  ) {
    const flag = confirm(`¿Está seguro que desea borrar la encuesta "${survey.title}"?`);

    if (flag) {
      await this.surveyService.delete(survey);
    }
  }

  open(
    survey?: Survey
  ) {
    const modalRef = this.modalService.open(
      SurveyModalComponent
    );

    modalRef.componentInstance.neighborhoodId = this.neighborhoodId;
    modalRef.componentInstance.survey = survey;
  }

}
